import client from '@stores/apollo'
import gql from 'graphql-tag'
import { AssignmentPlanFragment } from '@api/fragments'
import { IAssignmentPlan } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface PromoteAssignmentPlanMutationInput {
  id: string
}

interface IPayload {
  promoteAssignmentPlan: {
    assignmentPlan: IAssignmentPlan
  }
}

const mutateHandler = handleFetchResult<IPayload, IAssignmentPlan>({
  handler: (data) => data.promoteAssignmentPlan.assignmentPlan,
  name: 'Assignment Plan',
})

export default function promote(
  input: PromoteAssignmentPlanMutationInput
): Promise<IAssignmentPlan> {
  return client.gql.mutate<IPayload>({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation PromoteAssignmentPlan($input: PromoteAssignmentPlanMutationInput!) {
    promoteAssignmentPlan(input: $input) {
      assignmentPlan {
        ...AssignmentPlanFragment
      }
    }
  }
  ${AssignmentPlanFragment}
`
